import * as React from "react";

import { styled } from "@mui/material/styles";

const FieldSet = styled("fieldset")(() => ({
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor: "#969696",
  borderRadius: "10px",
  padding: "25px",
}));

const Legend = styled("legend")(() => ({
  padding: "4px 4px",
  margin: "auto",
  color: "#969696",
  fontSize: "14px",
}));

interface PowerUserProps {
  isPowerUser: boolean;
  children: React.ReactNode;
  fsx?: React.CSSProperties;
  lsx?: React.CSSProperties;
}

const PowerUser = ({ isPowerUser, fsx, lsx, children }: PowerUserProps) => {
  if (!isPowerUser) {
    return (
      <FieldSet sx={fsx && { ...fsx }}>
        <Legend sx={lsx && { ...lsx }}>Need power-user privileges. Contact organization administrator.</Legend>
        {children}
      </FieldSet>
    );
  }

  return <>{children}</>;
};

export default PowerUser;
